const newsRoute = [
  {
    path: '/news',
    component: () => import('@/views/news'),
    redirect: '/news/enterprise',
    meta: { title: '新闻资讯' },
    children: [
      {
        path: 'enterprise',
        component: () => import('@/views/news/enterprise/index.vue'),
        meta: { title: '企业新闻' }
      },
      {
        path: 'industry',
        component: () => import('@/views/news/industry/index.vue'),
        meta: { title: '行业新闻' }
      },
      {
        path: 'other',
        component: () => import('@/views/news/other/index.vue'),
        meta: { title: '其他新闻' }
      },
      {
        path: 'video',
        component: () => import('@/views/news/video/index.vue'),
        meta: { title: '视频专区' }
      },
      {
        path: 'detail/:category/:id',
        component: () => import('@/views/news/DetailPage.vue'),
        name: 'newsDetail',
        hidden: true,
        props: true,
        meta: {
          title: '新闻详情',
          breadcrumb: true,
          dynamicBreadcrumb: true, // 支持动态面包屑
          categoryMap: {
            'enterprise': '企业新闻',
            'industry': '行业新闻',
            'other': '其他新闻',
            'video': '视频专区'
          }
        }
      }
    ]
  },
]
export default newsRoute
